import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=5bcb6019&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"
import style0 from "./Player.vue?vue&type=style&index=0&id=5bcb6019&prod&scoped=true&lang=css"
import style1 from "./Player.vue?vue&type=style&index=1&id=5bcb6019&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcb6019",
  null
  
)

export default component.exports